import React, { Component, Fragment } from "react";
import DataGrid, {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import "devextreme/dist/css/dx.common.css";
import { Template } from "devextreme-react/core/template";
import Modal from "react-modal";
import Swal from "sweetalert2";
import "devextreme/dist/css/dx.light.css";
import { toast } from "react-toastify";
import SetDefaultHotelComponent from "../Shared/SetDefaultHotelComponent.js";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";

const CustomStyles = {
  content: {
    width: "30%",
    // /height: '30%'
  },
};
export class AirportComponent extends Component {
  static displayName = AirportComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      airportModelIsOpen: false,
      airportDataGridDataSource: null,
      loadPanelVisible: false,
      airportId: 0,
      addAirportCode: "",
      isActive: true,
      errors: {
        addAirportCode: 0,
      },
      isSetDefaultHotelModalOpen: false,
      rowData: null,
    };
    this.refDataGrid = React.createRef();
  }
  componentDidMount() {
    document.querySelector("#lblPageTitle").innerHTML = `Airport`;
    this.fetchGridDataOnPageLoad();
  }
  fetchGridDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        await this.getAirports();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  getAirports = async () => {
    try {
      this.refDataGrid.current.instance.beginCustomLoading();
      this.setState({
        loadPanelVisible: true,
      });
      let apiUrl = `${process.env.REACT_APP_API_BASE_URL}Airport/get-service-airports`;

      const data = await axiosPost(apiUrl, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      this.setState({
        airportDataGridDataSource: data.payload != null ? data.payload : [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAirports function",
        err,
      );
      this.setState({
        loadPanelVisible: false,
      });
    } finally {
      this.refDataGrid.current.instance.endCustomLoading();
    }
  };
  openTracking = (e, data) => {
    e.preventDefault();
    this.props.history.push({
      pathname: "/tracking",
      state: {
        airportId: data.airportId,
        sourceUrl: "/fleet-status",
        airportList: data,
      },
    });
  };
  getAirportTracking = (e, currentPageName, data) => {
    e.preventDefault();
    sessionStorage.setItem("session_PageName", currentPageName);
    this.props.history.push({
      pathname: "/tracking",
      state: { airportCode: data.airportCode, sourceUrl: "/airport" },
    });
  };
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  openAirportModel = (e) => {
    e.preventDefault();
    this.setState({
      airportModelIsOpen: true,
      addAirportCode: "",
    });
  };
  handleAirportSubmit = async (e) => {
    e.preventDefault();
    try {
      if (this.state.addAirportCode.trim() === "") {
        let formIsValid = true;
        let errors = this.state.errors;
        errors.addAirportCode = "";
        if (this.state.addAirportCode.trim() === "") {
          formIsValid = false;
          errors.addAirportCode = "Please enter airport.";
        }
        this.setState({ errors: errors });
        return formIsValid;
      }
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let UserId = parseInt(sessionStorage.getItem("session_userId"));
      this.setState({ isSubmited: true });
      var newObject = {};
      newObject.UserId = UserId;
      newObject.AirLineCode = airlineCode;
      newObject.AirportCode = this.state.addAirportCode;
      newObject.Enable = this.state.isActive;
      const data = await axiosPost(
        process.env.REACT_APP_API_BASE_URL +
          "Airport/insert-airline-airport-mapping",
        newObject,
      );
      if (data.isSuccess) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message,
        }).then((result) => {
          if (result.isConfirmed) {
            this.getAirports();
            this.closeUserModal();
          }
          this.setState({ isSubmited: false });
        });
      } else {
        toast.error(data.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
          style: { width: "310px" },
          hideProgressBar: false,
          newestOnTop: false,
          closeButton: false,
        });
        this.setState({ isSubmited: false });
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleUserSubmit function",
        err,
      );
      this.setState({ isSubmited: false });
    }
  };
  closeUserModal = () => {
    this.setState({
      isSubmited: false,
      airportModelIsOpen: false,
      addAirportCode: "",
      isActive: true,
      errors: {
        addAirportCode: 0,
      },
    });
  };

  handleOnCloseSetDefaultHotelModal = () => {
    try {
      this.setState((prev) => ({
        ...prev,
        isSetDefaultHotelModalOpen: false,
        rowData: null,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const renderTrackAirport = (data) => {
      return (
        <a
          href="!#"
          onClick={(e) => this.getAirportTracking(e, "Tracking", data.data)}
          title={`View ${data.data.airportName} fleet on map`}
          style={{
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "26px",
              height: "26px",
              borderRadius: "6px",
              background: "linear-gradient(135deg, #8E6448, #b07d5c)",
              color: "#fff",
              flexShrink: 0,
            }}
          >
            <i className="fas fa-plane" style={{ fontSize: "0.65rem" }} />
          </span>
          <span
            style={{ fontWeight: 600, fontSize: "0.82rem", color: "#5c3a1e" }}
          >
            {data.data.airportName}
          </span>
          <i
            className="fas fa-external-link-alt"
            style={{ fontSize: "0.6rem", color: "#b07d5c", marginLeft: "2px" }}
          />
        </a>
      );
    };
    const renderGridCell = (data) => {
      let setDefaultLink = "";
      setDefaultLink = (
        <a
          href="#"
          title="Set Default Hotel"
          onClick={(e) => {
            e.preventDefault();
            try {
              this.setState((prev) => ({
                ...prev,
                isSetDefaultHotelModalOpen: true,
                rowData: data?.data,
              }));
            } catch (error) {
              console.log(error);
            }
          }}
        >
          <i
            style={{
              cursor: "pointer",
              textAlign: "center",
              margin: "0px",
            }}
            className="fas fa-hotel"
          ></i>
        </a>
      );
      return <div style={{ textAlign: "left" }}>{setDefaultLink}</div>;
    };
    return (
      <Fragment>
        <style>{`
          /* ── Airport — theme matching sidebar #fff0e6 ── */
          .ca-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .ca-grid-wrap .dx-datagrid-filter-row td {
            background-color: #f5ede4 !important;
          }
          .ca-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .ca-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.6rem !important;
          }
        `}</style>
        <div className="card ca-grid-wrap">
          <div className="card-body">
            <DataGrid
              ref={this.refDataGrid}
              dataSource={this.state.airportDataGridDataSource}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={true}
              showRowLines={true}
              showColumnLines={true}
              onCellPrepared={(e) => {
                if (e.rowType === "header") {
                  e.cellElement.style.backgroundColor = "#fff0e6";
                  e.cellElement.style.color = "#000000";
                }
              }}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "after",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      onClick: async (e) => {
                        e.component.option("icon", "fas fa-spinner fa-spin");
                        await new Promise((resolve) =>
                          setTimeout(resolve, 1000),
                        ); // 0.5 sec
                        await this.getAirports();
                        e.component.option("icon", "refresh");
                      },
                    },
                  },
                  // {
                  //   location: "before",
                  //   template: "toolbarTemplateAddAirport",
                  // }
                );
              }}
            >
              <Column
                dataField="airportCode"
                caption=""
                allowSorting={false}
                allowFiltering={false}
                allowSearch={false}
                allowExporting={false}
                alignment={"left"}
                width={30}
                fixed={true}
                cellRender={renderGridCell}
              />
              <Column
                dataField="airportCode"
                caption="Airport Code"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={200}
              />
              <Column
                dataField="airportName"
                caption="Airport Name"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={400}
                cellRender={renderTrackAirport}
              />
              <Template
                name="toolbarTemplateAddAirport"
                render={() => {
                  return (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={this.openAirportModel}
                      >
                        <span title="Submit">
                          <i className="fas fa-plus"></i>Add Aiport
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <SortByGroupSummaryInfo summaryItem="count" />
              <GroupPanel visible={false} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Grouping autoExpandAll={true} />
              <Paging defaultPageSize={20} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="Airports"
              />
            </DataGrid>
          </div>
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.airportModelIsOpen}
          style={CustomStyles}
          className={"react-modal"}
          onAfterOpen={this.afterOpenviewEditModal}
          onRequestClose={this.editBaseLocationResetStateData}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <form
            method="post"
            onSubmit={this.handleAirportSubmit}
            style={
              this.state.isSubmited
                ? { pointerEvents: "none", opacity: "0.4" }
                : {}
            }
          >
            <div className="modal-header">
              <h6 className="modal-title">Add Airport</h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.closeUserModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="form-group">
                    <label>
                      Airport<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="addAirportCode"
                      title="AirportCode"
                      placeholder="Airport Code"
                      maxLength="3"
                      value={this.state.addAirportCode}
                      onChange={this.handleInputChange}
                    />
                    {this.state.errors["addAirportCode"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["addAirportCode"]}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className="col-xs-3 col-sm-3 col-md-3 col-lg-3"
                  style={{ marginTop: "19px" }}
                >
                  <div className="form-group">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="isActive"
                        name="isActive"
                        checked={this.state.isActive}
                        onChange={this.handleInputChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isActive"
                        style={{ fontSize: "inherit" }}
                      >
                        {" "}
                        Is Active &nbsp;
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                title="Submit"
              >
                {this.state.isSubmited && (
                  <span title="In-process">
                    <i className="fas fa-spinner fa-spin"></i> In-process
                  </span>
                )}
                {!this.state.isSubmited && (
                  <span title="Save">
                    <i className="fas fa-check"></i> Save
                  </span>
                )}
              </button>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={this.closeUserModal}
                title="Close"
              >
                <i className="fas fa-times" />
                &nbsp;Close
              </button>
            </div>
          </form>
        </Modal>
        {this.state.isSetDefaultHotelModalOpen && (
          <SetDefaultHotelComponent
            code={this.state.rowData?.airportCode}
            fromAirport={true}
            rowData={this.state.rowData}
            onRefresh={async () => {
              await this.getAirports();
            }}
            onClose={() => {
              this.handleOnCloseSetDefaultHotelModal();
            }}
          />
        )}
      </Fragment>
    );
  }
}
